import { useContext } from 'react';

import { Vacancy } from 'clients/AutoCompleteClient/types';
import { logger } from 'config/logger';
import { useGTM } from 'hooks/gtm';
import { useDeleteJobImprovedMutation } from 'hooks/shared/useDeleteJobImprovedMutation';
import { EnrichVacancyModalType } from 'shared/legacy/contexts/DialogContext/modals/EnrichVacancyModal/components/EnrichVacancyModalContext/EnrichVacancyModalContext.types';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useCreateSnackbar } from 'shared/legacy/contexts/SnackbarContext/useCreateSnackbar';
import { GlobalDialogType } from 'stores/global-dialogs/global-dialogs.store.types';
import { useGlobalDialog } from 'stores/global-dialogs/hooks/useGlobalDialog';
import { VacancyListTab } from '../VacancyList/VacancyList.types';

export const useVacancyActions = (selectedTab: VacancyListTab, onSelectVacancy: (vacancy: Vacancy | null) => void) => {
  const { dictionary } = useContext(LocalizationContext);
  const { mutateAsync: deleteJobImproved } = useDeleteJobImprovedMutation();
  const enrichVacancyModal = useGlobalDialog(GlobalDialogType.EnrichVacancy);
  const createSnackbar = useCreateSnackbar();
  const gtm = useGTM();

  const handleCreateJob = () => {
    enrichVacancyModal.open({
      payload: {
        modalType: selectedTab === VacancyListTab.AtsJobs ? EnrichVacancyModalType.Ats : EnrichVacancyModalType.Indeed,
      },
    });
  };

  const handleDeleteVacancy = async (vacancy: Vacancy) => {
    try {
      await deleteJobImproved(vacancy);

      onSelectVacancy(null);
    } catch (error) {
      logger.error(error);
      createSnackbar((error instanceof Error && error?.message) || dictionary.somethingWentWrong, {
        variant: 'danger',
      });
    }
  };

  const handleEditVacancy = (vacancy: Vacancy) => {
    if (!vacancy.is_improved) {
      gtm.clickOnEnrichedJob();
    }

    enrichVacancyModal.open({ payload: { vacancy } });
  };

  return { handleCreateJob, handleDeleteVacancy, handleEditVacancy };
};
